import { useEffect, useState } from 'react';
import { getFacebookPixelId } from '../../../utils';
import {
  FacebookPixel,
  PixelViewContentEvents,
} from '../../../utils/facebook-pixel';

export function usePixelViewContent(
  getViewContent: () => PixelViewContentEvents | null
): void;
export function usePixelViewContent<T>(
  getViewContent: () => PixelViewContentEvents | null,
  deps: T
): void;
export function usePixelViewContent<T extends ReadonlyArray<unknown>>(
  getViewContent: () => PixelViewContentEvents | null,
  deps?: T
): void {
  const [facebookPixelId] = useState(getFacebookPixelId());

  useEffect(() => {
    !!facebookPixelId && FacebookPixel.init(facebookPixelId);
  }, []);

  useEffect(() => {
    const viewContent = getViewContent();
    viewContent && FacebookPixel.viewContent(viewContent);
  }, deps || []);
}
